const render = ({pubid, nonsubmit, submitbutton}) => {
  return `
<form id="oiForm" name="oiForm" action="{nextURL}" method="post">
    <script type="text/javascript">
        oi_no_offers_url = "{nextURL}" ;
      var oi_non_submit = ${nonsubmit || false} // PAGE BEHAVIOR
        , oi_no_offers_url = "{nextURL}"
        , oi_hosted_sbmt_btn = ${submitbutton || false} // PAGE APPEARANCE
        , oi_firstname = "{firstName}"
        , oi_gender = "{gender}"
        , oi_dateofbirth = "{dob_dashes_mmddyyyy}"
        , oi_postalcode = "{zip}"
        , oi_sda_email = "{email}"
        , oi_sda_lastname = "{lastName}"
        , oi_sda_address1 = "{address1}"
        , oi_sda_homephone = "{phone}";
    </script>
  <input type="hidden" name="OI_FORM_IDENTIFIER" value="" />
<input type="hidden" id="subID" name="subID" value="{pe_key}"/>
   <script type="text/javascript" src="//www.clear-request.com/oi/second/${pubid}.js"></script>
  </form>
</div>
  `.trim()
};

export default render;